<template>
    <div class="table-responsive">
        <table class="table table-centered table-hover">
            <thead class="thead-light">
                <tr>
                    <th scope="col">
                        <div class="row">
                            <div class="col-5">{{ $root.text('Filename', null, true) }}</div>
                            <div class="col-3">{{ $root.text('Weight', null, true) }}</div>
                            <div class="col-3">{{ $root.text('Style', null, true) }}</div>
                            <div class="col-1">&nbsp;</div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td scope="row" :id="'template-font-file-row' + item.id" class="pb-0">
                        <div class="row">
                            <div class="col-5" style="padding-top: 3px">
                                <h5 class="font-size-14 mb-0">
                                    <a href="#" class="text-dark" @click.prevent="toggleEditTemplateFontFile(item)">
                                        {{ item.filename }}
                                    </a>
                                </h5>
                            </div>
                            <div class="col-3" style="padding-top: 3px">
                                {{ $root.text(getWeight(item.weight), null, true) }}
                            </div>
                            <div class="col-3" style="padding-top: 3px">
                                {{ $root.text(item.style, null, true) }}
                            </div>
                            <div class="col-1 font-size-18 contact-links">
                                <a
                                    href="#"
                                    class="float-right"
                                    @click.prevent="toggleEditTemplateFontFile(item)"
                                >
                                    <span
                                        v-if="(template_font_file_details_open.indexOf(item.id) < 0)"
                                        :key="'close-' + item.id"
                                    >
                                        <i class="fa-regular fa-chevron-circle-down"></i>
                                    </span>
                                    <span v-else :key="'open-' + item.id">
                                        <i class="fa-regular fa-chevron-circle-up"></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="row list-details-td mt-2">
                            <div
                                class="col-12 list-details"
                                :id="'template-font-file-details' + item.id"
                                style="padding-bottom: 103px"
                            >
                                <template-font-file-edit-form
                                    :data="item"
                                    :is_visible="(template_font_file_details_open.indexOf(item.id) > -1)"
                                ></template-font-file-edit-form>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: ['files'],
        data () {
            return {
                items: [],
                template_font_file_details_open: []
            }
        },
        mounted () {
            this.items = this.files;
        },
        watch: {
            files: function (val) {
                this.template_font_file_details_open = [];
                this.items = val;
            }
        },
        methods: {
            toggleEditTemplateFontFile: function (template_font_file) {
                if (this.template_font_file_details_open.indexOf(template_font_file.id) < 0) {
                    this.template_font_file_details_open.push(template_font_file.id);
                    $('#template-font-file-row' + template_font_file.id).addClass('highlighted');
                    $('#template-font-file-details' + template_font_file.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#template-font-file-details' + template_font_file.id).slideUp('slow', function () {
                        $('#template-font-file-row' + template_font_file.id).removeClass('highlighted');
                        for (var n = 0; n < vm.template_font_file_details_open.length; n++) { 
                            if (vm.template_font_file_details_open[n] == template_font_file.id) { 
                                vm.template_font_file_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            },
            getWeight: function (weight) {
                switch (weight) {
                    case 'extraLight':
                        return 'Extra light';
                    case 'semiBold':
                        return 'Semi bold';
                    case 'extraBold':
                        return 'Extra bold';
                    default:
                        return weight;
                }
            }
        }
    }
</script>
